import { FC, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { isEmpty } from 'radash';
import { allCollectionStore } from '@modules/collections/adapter/outbound/stores/allCollection.store';
import { loadingStore } from '@modules/core/adapter/outbound/stores/ui.store';
import { Container, Title } from '@components/collection/allCollection/AllCollectionLayout.style';
import { Content } from '@components/layouts';
import breakpoint from '@shared/assets/breakpoint.json';
import { useWindowSize } from '@shared/utils/hooks';
import { analytics } from '@shared/utils/segment.utils';
const AllCollectionLayout = dynamic(() => import('@components/collection/allCollection/AllCollectionLayout'));
const ViewMoreButton = dynamic(() => import('@components/viewMoreButton/ViewMoreButton'));
const AllCollectionProvider: FC = () => {
  const {
    width
  } = useWindowSize();
  const [pageSize, setPageSize] = useState(0);
  const {
    isLoading
  } = loadingStore(state => state);
  const {
    allCollectionLimit,
    fetchAllCollectionLimit
  } = allCollectionStore(state => state);
  const {
    collections,
    canLoadMore
  } = allCollectionLimit;
  useEffect(() => {
    if (width > 0) {
      setPageSize(width > breakpoint.md - 1 ? 6 : 3);
    }
  }, [width]);
  useEffect(() => {
    if (pageSize > 0) fetchAllCollectionLimit(1, pageSize);
  }, [pageSize]);
  const handleOnClickViewMoreButton = () => {
    const currentPage = allCollectionLimit.currentPage + 1;
    fetchAllCollectionLimit(currentPage, pageSize);
    analytics.track('All Collection View More Click', {
      event: 'All Collection View More Click'
    });
  };
  return <Container>
            <Content>
                <Title>
                    คอลเลกชันทั้งหมด <span>({allCollectionLimit.total})</span>
                </Title>
                {!isEmpty(collections) && <>
                        <AllCollectionLayout data={allCollectionLimit.collections} />
                        {canLoadMore && <ViewMoreButton text="ดูเพิ่มเติม" isLoading={isLoading} loadingAnimateDuration={1} onClick={handleOnClickViewMoreButton} />}
                    </>}
            </Content>
        </Container>;
};
export default AllCollectionProvider;